// extracted by mini-css-extract-plugin
export var shake = "_12-0";